// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608120342/js/" + chunkId + "." + {"44":"54008456","225":"ba167a5a","481":"dd07e949","486":"de64c2f0","770":"34e4324a"}[chunkId] + ".0.23374676264623062.chunk.js";
};